import React from 'react';
import { Form as FormLayout } from 'semantic-ui-react';

export const Form = ({ className, children, onSubmit, style }) => (
  <FormLayout
    as="form"
    className={className}
    style={style}
    onSubmit={(e) => {
      e.preventDefault();
      onSubmit();
    }}
  >
    {children}
  </FormLayout>
);
